export default __webpack_public_path__ + "static/media/Edit_Dark2.e2bb9288.svg";